import { lazyRouteComponent } from "@tanstack/react-router";
import { BadgeCheck, Landmark } from "lucide-react";

import type { PageDef } from "@/app/registry";

import { parseDirectorySearch } from "./data";

/**
 * The public directories: search SEBI-registered Research Analysts and
 * Investment Advisers and see a profile (kinds.ts holds what differs). The
 * API is public (no sign-in). The pages also work outside the signed-in
 * shell; `publicPages` is what the integration step mounts on the public site
 * (see the module's integration notes).
 */
export const pages: PageDef[] = [
  {
    path: "/find-research-analyst/$regNo",
    title: "Research Analyst",
    component: lazyRouteComponent(
      () => import("./RaProfilePage"),
      "RaProfilePage",
    ),
  },
  {
    path: "/find-research-analyst",
    title: "Find a Research Analyst",
    component: lazyRouteComponent(
      () => import("./DirectoryPage"),
      "DirectoryPage",
    ),
    nav: {
      label: "Find a SEBI Research Analyst",
      icon: BadgeCheck,
      group: "Analysts",
      order: 0,
    },
    validateSearch: parseDirectorySearch,
    // "Find an RA" is for investors (and admins); RAs don't see it in the
    // menu, nor an RA's clients (their analyst brought them)
    roles: ["admin", "investor"],
    notForRaClients: true,
  },
  {
    path: "/find-investment-adviser/$regNo",
    title: "Investment Adviser",
    component: lazyRouteComponent(
      () => import("./RaProfilePage"),
      "AdviserProfilePage",
    ),
  },
  {
    path: "/find-investment-adviser",
    title: "Find an Investment Adviser",
    component: lazyRouteComponent(
      () => import("./DirectoryPage"),
      "AdviserDirectoryPage",
    ),
    nav: {
      label: "Find an Investment Adviser",
      icon: Landmark,
      group: "Analysts",
      order: 1,
    },
    validateSearch: parseDirectorySearch,
    // listed from SEBI's register only (no platform features); same audience as "Find an RA"
    roles: ["admin", "investor"],
    notForRaClients: true,
  },
];

export const publicPages = pages;
